import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import axios from "axios";

import Header from "../../components/Header";
import {
  ApplyForm,
  Banner,
  Container,
  Content,
  DualContent,
  UploadButton,
  SubmitButton,
  ScrollCarousel,
} from "./styles";
import { FaCheck, FaFileUpload } from "react-icons/fa";

import Footer from "../../components/Footer";
import eolica from "../../assets/images/windintelli_loading.png";
import eolica1 from "../../assets/images/eolica/eolica1.jpeg";
import eolica2 from "../../assets/images/eolica/escritorio.jpg";
import eolica3 from "../../assets/images/eolica/eolica3.jpeg";
import eolica4 from "../../assets/images/eolica/eolica4.jpg";
import gravata from "../../assets/images/eolica/gravata.jpeg";

export function Carrer() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [text, setText] = useState("");
  const [resumeFile, setResumeFile] = useState<File>();
  const [showSuccessText, setShowSuccessText] = useState(false);
  const [resumeButtonText, setResumeButtonText] = useState("Add Resume");
  const fileInput = useRef<HTMLInputElement>(null);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  const handleFileUpload = (event: ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    event.preventDefault();
    const fileList = event.target.files;
    if (!fileList) return;

    setResumeButtonText(fileList[0].name);

    setResumeFile(fileList[0]);
  };

  const triggerclick = () => {
    if (fileInput.current) fileInput.current.click();
  };

  const submitForm = async () => {
    const formData = new FormData();

    formData.append("name", name);
    formData.append("email", email);
    formData.append("text", text);
    if (resumeFile) {
      formData.append("file", resumeFile, resumeFile.name);
    }

    await axios.post(
      "https://api.windintelli.com/careers_send_email",
      formData
    );

    setShowSuccessText(true);
    setName("");
    setEmail("");
    setText("");
    setResumeButtonText("Add Resume");
  };

  return (
    <>
      <Header />
      <Container>
        <Banner>
          <div>
            <h1>Want to work with us?</h1>
            <p>Join us and move thinking foward</p>
          </div>
        </Banner>
        <Content>
          <DualContent>
            <div>
              <h3>About Eólica</h3>
              <h1>
                Eólica Tecnologia is one of the leading companies in Brazil
                acting in the development, construction and operation of wind
                farms.
              </h1>
            </div>
            <div>
              <ul>
                <li>
                  <FaCheck size={25} />
                  <span>
                    We are <b>pioneers </b>in <b> renewable energy</b>
                  </span>
                </li>
                <li>
                  <FaCheck size={25} />
                  <span>
                    We work with <b>innovation</b> and <b>excellence</b>{" "}
                  </span>
                </li>
                <li>
                  <FaCheck size={25} />
                  <span>
                    We are <b>goal-driven </b>and <b>dedicated</b>{" "}
                  </span>
                </li>
                <li>
                  <FaCheck size={25} />
                  <span>
                    We thrive together as <b>a team</b>
                  </span>
                </li>
                <li>
                  <FaCheck size={25} />
                  <span>
                    We believe in <b>people's ability to grow</b>
                  </span>
                </li>
              </ul>
            </div>
          </DualContent>

          <hr />
          <ScrollCarousel>
            <div>
              <img
                src={eolica2}
                alt="Mulher sentada trabalhando no computador"
              />
              <img src={eolica3} alt="Pessoas reunidas em torno de mesa" />
              <img src={gravata} alt="Sala de reunião" />
              <img
                src={eolica1}
                alt="Pessoas pousando para foto em evento de energia"
              />
              <img src={eolica} alt="Escritório da eólica" />
              <img
                src={eolica4}
                alt="Mulher sentada trabalhando no computador"
              />
            </div>
          </ScrollCarousel>
          <hr />

          <ApplyForm>
            <h3>Apply Now</h3>
            <p>
              Tell us a little about yourself, your experiences and why you’d be
              a good fit for our team.
            </p>

            <input
              type="text"
              placeholder="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <textarea
              name=""
              id=""
              rows={5}
              placeholder="Message"
              value={text}
              onChange={(e) => setText(e.target.value)}
            ></textarea>
            <input
              ref={fileInput}
              onChange={handleFileUpload}
              type="file"
              accept=".pdf"
              style={{ display: "none" }}
            />
            <UploadButton
              className="pdfUpload"
              onClick={(e) => {
                e.preventDefault();
                triggerclick();
              }}
            >
              {" "}
              <FaFileUpload size={18} /> {resumeButtonText}
            </UploadButton>
            {showSuccessText && (
              <span>Thank you for your submit. We'll be on touch soon.</span>
            )}
            <SubmitButton type="button" onClick={submitForm}>
              Apply
            </SubmitButton>
          </ApplyForm>
        </Content>
      </Container>
      <Footer />
    </>
  );
}
